import styled from 'styled-components';

import {colors} from 'theme';

export const HelperContainer = styled.div<{visible?: boolean; maxWidth?: string}>`
    z-index: 1000;
    background: ${colors.white};
    color: #1d2229;
    padding: 10px;
    border-radius: 12px;
    font-size: 14px;
    font-weight: 400;
    white-space: wrap;
    line-height: 18px;
    max-width: ${({maxWidth}) => maxWidth ?? '230px'};
    width: max-content;
    text-align: left;
    box-shadow: 0 2px 8px #6e6e6e4d;
    opacity: ${({visible}) => (visible ? 1 : 0)};
    pointer-events: ${({visible}) => (visible ? 'auto' : 'none')};
    visibility: ${({visible}) => (visible ? 'auto' : 'hidden')};
    transition: all 0.15s ease-in-out;
`;
